// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__AxfIB","primary":"Button_primary__1n7q8","secondary":"Button_secondary__pRvhC","outlined":"Button_outlined__ZQVHT"};